import React, { useEffect, useState } from "react";
import { Card, Input, Button, Form, message } from "antd";
import PageHeader from "../../components/shared/PageHeader";
import { deleteAccount } from "../../api/user";
import { logout } from "../../helpers/auth/useSession";
import CompanyForm from "../../components/company/CompanyForm";
import { deleteCompanyAccount, getCompany } from "../../api/company";
import { getFileUrl } from "../../api/file";
import PricingSection from "../../components/PricingTable/pricingTable";
import { getSubscriptions } from "../../api/subscription";

export default function SettingsView({ user }) {
  const [form] = Form.useForm();
  const [companyDeleteForm] = Form.useForm();
  const [isDeleting, setIsDeleting] = React.useState(false);

  const [company, setCompany] = useState(undefined);
  const [subscriptions, setSubscriptions] = useState([]);

  const fetchData = async () => {
    try {
      const companyRes = await getCompany();
      const subscriptions = await getSubscriptions();

      // Converting logo into required format
      let logo = companyRes.logo && [
        {
          ...companyRes.logo,
          uid: companyRes.logo.id,
          name: companyRes.logo.name,
          status: "done",
          url: getFileUrl(companyRes.logo),
        },
      ];
      companyRes.logo = logo;

      // Will be used as an initial value
      setCompany(companyRes);
      setSubscriptions(subscriptions.results)
      console.log(subscriptions.results)
    } catch (error) {
      message.error("Something went wrong, please try again later");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (values) => {
    const v = await form.validateFields();
    setIsDeleting(true);
    const res = await deleteAccount(v.password);
    if (res.Code === 1) {
      await logout();
      message.success("Account deleted successfully");
    } else {
      if (res.Data.Code === 101) {
        message.error("Invalid password");
      } else {
        message.error("Something went wrong, please try again later");
      }
    }
    setIsDeleting(false);
  };

  const handleCompanyDelete = async (values) => {
    const v = await companyDeleteForm.validateFields();
    setIsDeleting(true);
    const res = await deleteCompanyAccount(v.pwd);
    if (res.Code === 1) {
      await logout();
      message.success("Account deleted successfully");
    } else {
      if (res.Data.Code === 101) {
        message.error("Invalid password");
      } else {
        message.error("Something went wrong, please try again later");
      }
    }
    setIsDeleting(false);
  };

  return (
    <main className="min-h-full flex flex-col gap-6">
      <PageHeader title="Settings" home="App" route="/" />

      <div className="flex-grow bg-white ml-6 p-6 flex flex-col gap-6">
        {user.role === "admin" && company && (
          <Card title="Company">
            <div className="py-4 px-6">
              <CompanyForm
                initialValues={{
                  id: company.id,
                  name: company.name,
                  phone: company.phone,
                  address: company.address?.name,
                  country: company.address?.country,
                  timezone: company.address?.timezone,
                  logo: company.logo,
                }}
              />
            </div>
          </Card>
        )}

        {user.role === "admin" && company && (
          <PricingSection pricingPlans={subscriptions} />
        )}


        <Card
          title="Danger Zone"
          id="delete-profile"
          className="border-red-500"
        >
          <div className="py-4 px-6">
            <div className="flex flex-col ">
              <p className="font-semibold text-lg">Delete Account</p>
              <span>
                Once you delete your account, there is no going back. Please
                enter your password to confirm.
              </span>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleDelete}
                className="mt-4"
              >
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>
                <Button
                  disabled={isDeleting}
                  loading={isDeleting}
                  className="border-red-500"
                  htmlType="submit"
                >
                  Delete Account
                </Button>
              </Form>
            </div>
          </div>

          {user.role === "admin" && (
            <div className="mt-6 py-4 px-6">
              <p className="font-semibold text-lg">Delete Company</p>
              <span>
                Once you delete your company, all of its associated data will be
                erased. This will also delete accounts associated with it.
              </span>
              <Form
                form={companyDeleteForm}
                layout="vertical"
                onFinish={handleCompanyDelete}
                className="mt-4"
              >
                <Form.Item
                  name="pwd"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>
                <Button
                  disabled={isDeleting}
                  loading={isDeleting}
                  className="border-red-500"
                  htmlType="submit"
                >
                  Delete Company
                </Button>
              </Form>
            </div>
          )}
        </Card>
      </div>
    </main>
  );
}
